<div class="card shadow-sm">
  <div class="card-body">
    <div class="row justify-content-between">
      <div>
        <ul class="nav d-flex align-items-center">
          <li class="nav-item font-weight-bold text-primary font-size-normal mr-auto d-flex align-items-center">
            {{title |translate}}
          </li>
        </ul>
      </div>

      <div>
        <ul [ngClass]="{'nav d-flex align-items-left justify-content-center': left, 'nav d-flex align-items-center justify-content-center': !left}">
          @for (item of items; track item) {
            <li class="nav-item mr-3">
              <button type="button" class="btn btn-link font-weight-bold" [ngClass]="{'text-primary': item.active, 'text-tertiary': !item.active}"
                (click)="setActive(item)">
                {{ item.timestamp ? (item.timestamp | dateTimeFormatPipe: 'dm':tz.selectedOption) : item.name | translate }}
              </button>
            </li>
          }
        </ul>
      </div>

      @if (showCheckbox) {
        <div class="d-flex" [style.right.rem]="1">
          <div [hidden]="!exportedData" class="pr-3">
            <app-export-data
              [tableToExport]="exportedData?.data"
              [fileName]="exportedData?.fileName"
              customLabel="BUTTONS.EXPORT_ALL_AVAILABILITIES">
            </app-export-data>
          </div>
          <div class="font-weight-bold text-primary font-size-small show-charts">
            <input type="checkbox" [(ngModel)]="checkboxState" (change)="boxValueChanged($event)"/>&nbsp;&nbsp;&nbsp;{{checkboxTitle | translate}}
          </div>
        </div>
      }

    </div>
  </div>
</div>
